import React from 'react';
import memoize from 'memoize-one';
import { BasicActionBtns, DatatableEmployeeName } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'RUT Y NOMBRE',
    selector: 'employee_name',
    cell: item => (
      <DatatableEmployeeName item={item.employee} fileName="file_info" name="full_name" fileUrl="file_url" />
    ),
    sortable: true,
    grow: '2'
  },
  {
    name: 'NOMBRE DNC',
    selector: 'dnc_name',
    cell: item => item.dnc?.label,
    sortable: true,
    grow: '1'
  },
  {
    name: 'TEMA',
    selector: 'topic',
    sortable: true,
    cell: item => item.topic?.label
  },
  {
    name: 'NIVEL PROF',
    selector: 'depth_level',
    cell: item => item.translated_depth_level,
    sortable: true,
    grow: '1'
  },
  {
    name: 'NIVEL URGENCIA',
    selector: 'urgency_level',
    cell: item => item.translated_urgency_level,
    sortable: true,
    grow: '1'
  },
  {
    name: 'CURSO',
    selector: 'course_name',
    sortable: true,
    grow: '1'
  },
  {
    name: 'ESTADO CURSO',
    selector: 'course_status',
    sortable: true,
    grow: '1'
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <BasicActionBtns
        item={item}
        resource="Dnc"
        clickHandler={clickHandler}
        withShow={false}
        withEdit
        withDestroy={false}
      />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    grow: '1',
    minWidth: '123px'
  }
]);

export default columns;
